import React, {useState} from "react";
import Lung from "../../../assets/images/organs/72x72/Lung_Up_72x72.png";
import LungHover from "../../../assets/images/organs/72x72/Lung_Over_72x72.png";
function LungIcon(props) {
    const [isHover, setIsHover] = useState(false);

    if (props.showHover) {
        return (
            <div 
                className={props.count ? "icon-container organ-count-wrapper" : "icon-container"}
                onMouseEnter={()=> setIsHover(true)}
                onMouseLeave={()=> setIsHover(false)}
            >
                <img src={isHover ? LungHover : Lung} alt="Lung Icon" className="organ-icon" />
                {props.count &&
                    <div className="organ-count lung">
                        {props.count}
                    </div>
                }
            </div>
        );
    }
    else {
        return (<img src={Lung} alt="Lung Icon" className="organ-icon" />);
    }
}

export default LungIcon;